import { createTheme } from "@mui/material"

const colorTheme = {
    palette: {
        primary: {
            main: '#A91674',
        },
        secondary: {
            main: '#E6204B',
        },
        dark:{
            main:"#000"
        },
        light:{
            main:"#fff"
        },
        grey:{
            main:"#F0EFF0",
            light:"rgba(95, 95, 95, 1)",
            200:"#F4F4F4"
        }
    }
    
}

export default colorTheme